import { isString } from 'lodash';
import pathfinder from '@fiverr-private/pathfinder';
import { PATHFINDER, formatQueryParams } from '../../utils';
import type { MapperItemConfig } from './types';

export const getSearchQueryPath = ({ query, filter, id, queryParams, source }: MapperItemConfig) => {
    let params;
    if (isString(queryParams)) {
        params = { query, ref: queryParams };
        if (id) {
            params = { ...params, sub_category: id };
        }
    } else {
        // @ts-expect-error - queryParams cannot be an object here
        params = { ...queryParams, query };
    }

    return pathfinder(PATHFINDER.SEARCH, {}, formatQueryParams({ filter, queryParams: params, source }));
};
